import { render, staticRenderFns } from "./specificationCell.vue?vue&type=template&id=76df3566"
import script from "./specificationCell.vue?vue&type=script&lang=js"
export * from "./specificationCell.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports